import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { FormBuilder, FormGroup, FormControl, Validators, FormGroupDirective } from '@angular/forms';
import { NewUser } from '../../queries/users.model';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { UserService } from '../../shared/services/user.service';
import { AuthService } from '../../shared/services/auth.service';
import { ArtistSearchService } from '../../shared/services/artist-search.service';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import { Constants } from '../../helpers/constants';

@Component({
  selector: 'my-new-user',
  template: require('./new-user-form.component.html'),
  styles: [require('./new-user-form.component.scss')]
})

export class UserFormComponent implements OnInit, OnDestroy, AfterViewInit {
  public clientRole = ['Affiliate Label', 'Artist Manager', 'Artist', 'Other'];
  public userType = ['External VIP', 'External Restricted'];
  public oktaTenent = ['Global', 'Branded'];
  public tenant: any;
  public Utype: any;
  public Urole: any;
  public dizzeeTenant: any;
  public userPhoneNumber: '';
  public individualArtist: boolean;
  public revenueAccess: boolean;
  public enableRevenueAccess: boolean = false;
  public enableUmdAccessToggle: boolean = false;
  public discoverAccess: boolean = false;
  public strRoleSelected: string = '';
  public strUserTypeSelected: string = '';
  public artistSelected: boolean;
  public isArtistOrLabelSelected: boolean;
  public isArtistSelected: boolean;
  public external: boolean;
  public userFirstName: '';
  public userEmail: '';
  public flHidden: boolean;
  public iaHidden: boolean;
  public userCountry: '';
  public userCompany: '';
  public userLastName: '';
  public defaultLabels: any;
  public defaultLabelsList: any;
  public subLabels: any;
  public subLabelsList: any = [];
  public showSubLabelsList: Boolean = false;
  public countryList: [''];
  public originalDefaultLabels: any;
  public originalCountriesList: any;
  public checkNewUser: any;
  public isFromValid: boolean;
  public userData: any = {};
  public submitted: Boolean;
  public userExists: Boolean;
  public artistExists: boolean;
  public selectedArtist = [];
  public artists: any = [];
  public user: any;
  public error: '';
  public config: object;
  // public branding = [
  //   {id: 'default', name: 'UMX' },
  //   {id: 'uma', name: 'UMA'},
  //   {id:'bm', name: 'Because Music'}
  // ];

  public keyUp = new Subject<string>();
  newUserSub: Subscription;
  updateUserForm: FormGroup;

  @ViewChild('lgModal') public lgModal: ModalDirective;
  @ViewChild('smModal') public smModal: ModalDirective;
  @ViewChild('f') public f: FormGroupDirective;
  @Output() uploaded: EventEmitter<string> = new EventEmitter();
  @Output() loadWebReq: EventEmitter<string> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private apollo: Apollo,
    private router: Router,
    private userService: UserService,
    private searchService: ArtistSearchService,
    private authService: AuthService,
    private location: Location) {
    this.keyUp
      .map((value) => value)
      .debounceTime(500)
      .distinctUntilChanged()
      .flatMap((search) => {
        return Observable.of(search).delay(500);
      })
      .subscribe((term) => this.search(term));
    let eparams = this.location.path();
    if (eparams === '/new-user') {
      this.external = true;
    } else {
      this.external = false;
    }
  };

  // Initializing the Modal

  ngAfterViewInit() {
    this.lgModal.show();
  }

  // Search Functionality
  search(term) {
    let artistArray = [];
    // console.log('New user artist search', term);
    let tempData;
    if (_.trimStart(term, ' ').length === 0) {
      return;
    }
    this.searchService.searchArtist(term).subscribe(
      (res) => {
        // console.log(res);
        tempData = res;
      },
      (err) => console.log(err),
      () => {
        this.artists = tempData.searchArtists;
        // console.log(this.artists);
        this.artists.forEach(function (a) {
          // console.log(a.name);
          artistArray.push(a);
        });
      });

  }

  // External users form restriction functionality depending on role and Family label

  selectedRole(role: any) {
    // console.log('selected role', role);
    this.strRoleSelected = role;
    switch (role) {
      case 'Affiliate Label':
        this.flHidden = false;
        this.iaHidden = true;
        this.showSubLabelsList = true;
        const x = this.userService.externalVip.indexOf(this.defaultLabels);
        if (x === -1) { // this.defaultLabels !== 'Disney' &&  this.defaultLabels !== 'Concord'
          this.userType = ['External Restricted'];
        } else {
          this.userType = ['External VIP', 'External Restricted'];
        }
        break;
      case 'Other':
        this.flHidden = false;
        this.iaHidden = false;
        this.showSubLabelsList = false;
        const i = this.userService.externalVip.indexOf(this.defaultLabels);
        if (i === -1) { // this.defaultLabels !== 'Disney' &&  this.defaultLabels !== 'Concord'
          this.userType = ['External Restricted'];
        } else {
          this.userType = ['External VIP', 'External Restricted'];
        }
        break;

      case 'Artist Manager':
      case 'Artist':
      default:
        this.updateUserForm.controls['defaultLabels'].patchValue('', { onlySelf: true });
        this.flHidden = true;
        this.iaHidden = false;
        this.showSubLabelsList = false;
        this.userType = ['External Restricted'];
        break;
    }
  }

  selectedFl(fl: string) {
    this.updateUserForm.controls['subLabels'].patchValue('', { onlySelf: true });

    let tempData;
    this.userService.getSubLabels(fl).subscribe(
      (res) => {
        tempData = res;
      },
      (err) => {
        console.log(err);
      }, () => {
        this.subLabelsList = tempData.getSubLabels;
      });

    let i = this.userService.externalVip.indexOf(fl);
    if (i !== -1) {
      this.userType = ['External VIP', 'External Restricted'];
    } else {
      this.userType = ['External Restricted'];
      this.defaultLabels = '';
      this.updateUserForm.controls['Utype'].patchValue('', { onlySelf: true });
    }
  }

  selectedUserType(userType: any) {
    this.strUserTypeSelected = userType;
    this.validateRevenueAccess();
  }

  validateRevenueAccess() {
    if ((this.strRoleSelected === 'Affiliate Label' || this.strRoleSelected === 'Other') &&
      (this.strUserTypeSelected === 'External Restricted') && this.authService.userLoginType === 'admin') {
      this.enableRevenueAccess = true;
    } else {
      this.enableRevenueAccess = false;
    }
  }

  umdAccessToggle(e: any) {
    if (e.target.checked && (this.isArtistOrLabelSelected || this.isArtistSelected)) {
      this.isArtistOrLabelSelected = false;
      this.isArtistSelected = false;
    }
  }

  // Modal Functionality to navigate from one modal to other

  selectArtistModal() {
    this.artistSelected = false;
    this.lgModal.hide();
    this.smModal.show();
  }

  previousModal() {
    this.smModal.hide();
    this.lgModal.show();
  }

  removeFilter(i) {
    this.selectedArtist.splice(i, 1);
  }

  cancelForm() {
    if (!this.userService.showNewUser) {
      if (this.lgModal.isShown) {
        this.lgModal.hide();
      } else {
        if (this.smModal.isShown) {
          this.smModal.hide();
        }
      }
      this.userService.showAddExternal = false;
      this.router.navigateByUrl('external');
    } else {
      if (this.userService.showNewUser) {
        if (this.lgModal.isShown) {
          this.lgModal.hide();
        } else {
          if (this.smModal.isShown) {
            this.smModal.hide();
          }
        }
        this.userService.showNewUser = false;
        this.router.navigateByUrl('requests');
      }

    }
  }

  // Validating the form

  formValidation(value) {
    // console.log('value for user check', value);
    if (this.f.valid) {
      this.checkIfNewUser(value);
      this.isFromValid = false;
    } else {
      this.isFromValid = true;
    }
  }

  // Check if USer already exists

  checkIfNewUser(value) {
    // console.log('Form Validation', this.f.valid );
    let tempData;
    this.checkNewUser = this.userService.checkNewUser(value.email).subscribe(
      (res) => {
        // console.log(res);
        tempData = res;
      },
      (err) => {
        console.log(err);
      },
      () => {
        if (tempData.checkUserExists === false) {
          this.updateForm(value);

          if (this.updateUserForm.controls['discoverAccess'].value && !this.updateUserForm.controls['individualArtist'].value) {
            this.submitNewUser();
            this.userExists = false;
            return;
          }
          if (this.updateUserForm.controls['Urole'].value === 'Affiliate Label' ||
            this.updateUserForm.controls['Urole'].value === 'Other') {
            if (this.updateUserForm.controls['defaultLabels'].value === '' &&
              !this.updateUserForm.controls['individualArtist'].value) {
              return this.isArtistOrLabelSelected = true;
            } else if (this.updateUserForm.controls['individualArtist'].value) {
              this.isArtistOrLabelSelected = false;
              this.selectArtistModal();
            } else {
              this.submitNewUser();
            }
          } else if (this.updateUserForm.controls['Urole'].value === 'Artist Manager' ||
            this.updateUserForm.controls['Urole'].value === 'Artist') {
            if (this.updateUserForm.controls['individualArtist'].value === false) {
              return this.isArtistSelected = true;
            } else if (this.updateUserForm.controls['individualArtist'].value) {
              this.isArtistSelected = false;
              this.selectArtistModal();
            }
          }
          this.userExists = false;
        } else {
          if (tempData.checkUserExists === true) {
            this.userExists = true;
          }
        }
      }
    );
  }

  // Default Label and artist to Update the Form

  getDefaultLabel(label) {
    let i = _.findIndex(this.originalDefaultLabels, { name: label });
    // console.log('//// i ////', i);
    let d = this.originalDefaultLabels[i];
    // console.log('d: ', d);
    return _.isUndefined(d) || i === -1 ? {
      name: null,
      id: null,
      type: 'Family'
    }
      : {
        name: (d as any).name,
        id: (d as any).id,
        type: 'Family'
      };
  }

  getCountryObject(country) {
    // console.log('country', country);
    let i = _.findIndex(this.originalCountriesList, { name: country });
    // console.log('//// i ////', i);
    let d = this.originalCountriesList[i];
    // console.log('d: ', d);
    return _.isUndefined(d) || i === -1 ? {
      name: null,
      code: null
    }
      : {
        name: (d as any).name,
        code: (d as any).id
      };
  }

  addArtist(artist) {
    this.artistSelected = false;
    let isAlreadyArtistSelected = _.some(this.selectedArtist, function (obj) {
      return obj._id === artist._id;
    });
    if (isAlreadyArtistSelected) {
      // console.log('Artist already selected');
      this.artistExists = true;
    } else {
      this.artistExists = false;
      let newArtist = { _id: artist._id, name: artist.name, image: artist.image };
      this.selectedArtist.push(newArtist);
    }
    // console.log(this.selectedArtist);
  }




  // Updating the user input Values to the Variables

  updateForm(value: any): void {
    // console.log('value', value);
    const userInput = {
      internal: false,
      active: true,
      email: value.email === null ? this.userEmail : value.email,
      firstName: value.firstName === null ? this.userFirstName : value.firstName.charAt(0).toUpperCase() + value.firstName.slice(1),
      lastName: value.lastName === null ? this.userLastName : value.lastName.charAt(0).toUpperCase() + value.lastName.slice(1),
      createdUserId: this.authService.userLoginObject['_id'],
      tenantName: value.dizzeeTenant === 'bm' ? 'BRANDED' : 'GLOBAL',
      info: {},
      account: {
        config: {
          branding: value.dizzeeTenant ? value.dizzeeTenant : this.tenant,
          appAccess: null
        }
      },
      applications: [],
      discoverAccess: false
    };

    userInput.info = {
      company: value.company === null ? this.userCompany : value.company,
      country: value.country === null ? null : this.getCountryObject(value.country),
      phoneNumber: value.phoneNumber.toString() === null ? this.userPhoneNumber.toString() : value.phoneNumber.toString(),
      clientRole: value.role === null ? this.Urole : value.Urole,
    };

    userInput.applications.push({
      name: Constants.EXTAPPNAME,
      userType: value.Utype === null ? this.Utype : value.Utype,
      defaultLabel: null,
      r2SubLabels: null,
      accessArtists: null,
      revenueAccess: {
        canView: this.enableRevenueAccess ? value.revenueAccess ? true : false : false
      }
    },
      {
        name: Constants.EXTAPPTRENDS,
        userType: value.Utype === null ? this.Utype : value.Utype,
        defaultLabel: null,
        r2SubLabels: null,
        accessArtists: null,
        revenueAccess: {
          canView: this.enableRevenueAccess ? value.revenueAccess ? true : false : false
        }
      }
    );

    if (userInput.applications[0].revenueAccess.canView) {
      userInput.applications[0].revenueAccess = {
        canView: this.enableRevenueAccess ? value.revenueAccess ? true : false : false,
        adminGrantedAccess: this.authService.userLoginType === 'admin' ? true : false,
        adminOid: this.authService.userLoginObject['_id'],
        adminEmail: this.authService.userLoginObject['email']
      }
    }

    if (userInput.applications[1].revenueAccess.canView) {
      userInput.applications[1].revenueAccess = {
        canView: this.enableRevenueAccess ? value.revenueAccess ? true : false : false,
        adminGrantedAccess: this.authService.userLoginType === 'admin' ? true : false,
        adminOid: this.authService.userLoginObject['_id'],
        adminEmail: this.authService.userLoginObject['email']
      }
    }

    if (value.defaultLabels) {
      userInput.applications[0]['defaultLabel'] = this.getDefaultLabel(value.defaultLabels);
      userInput.applications[1]['defaultLabel'] = this.getDefaultLabel(value.defaultLabels);
      userInput.applications[0]['r2SubLabels'] = value.subLabels ? value.subLabels : [];
      userInput.applications[1]['r2SubLabels'] = value.subLabels ? value.subLabels : [];
    }
    userInput.discoverAccess = value.discoverAccess ? value.discoverAccess : false;
    this.userData = userInput;
    // this.checkIfNewUser() ? this.newUserQuery(userInput) : this.updateUserQuery(userInput);

  }

  // Custom  Form Validations

  validateEmail(c: FormControl) {
    /* tslint:disable */
    let EMAIL_REGEXP = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');
    /* tslint:enable */
    return EMAIL_REGEXP.test(c.value) ? null : {
      validateEmail: {
        valid: true
      }
    };
  }

  validatePhone(c: FormControl) {
    // accept a number that's at least 10 digits and up to 15
    /* tslint:disable */
    let PHONE_REGEXP = new RegExp('^(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})$');

    return PHONE_REGEXP.test(c.value) ? null : {
      validatePhone: {
        valid: false
      }
    };
  }

  // Submitting the Form

  submitNewUser() {
    if (this.updateUserForm.controls['individualArtist'].value && !this.selectedArtist.length) {
      this.artistSelected = true;
    } else {
      this.artistSelected = false;
      if (this.selectedArtist.length) {
        this.userData.applications[0]['accessArtists'] = this.selectedArtist;
        this.userData.applications[1]['accessArtists'] = this.selectedArtist;
      }
      // console.log('User Input', this.userData);
      this.smModal.hide();
      this.lgModal.hide();
      // this.userService.showAddExternal = false;
      this.newUserQuery(this.userData);
    }
  }

  // Mutation to submit the New User

  newUserQuery(userInput) {
    this.newUserSub = this.apollo.mutate({
      mutation: NewUser,
      variables: {
        UserInput: userInput
      }
    })
      .subscribe(({ data }: any) => {
        if (data.createUser === null) {
          this.userExists = true;
        } else {
          // console.log('new user: ', data);
          this.submitted = true;
          if (this.userService.showNewUser) {
            this.userService.deleteRequest(this.userService.newUserObject).subscribe(() => {
              // console.log(res);
            }, (err) => { console.log(err); }, () => {
              this.loadWebReq.next();
            });
          }
          this.uploaded.next();
          this.userService.showAddExternal = false;
          // this.router.navigate(['/external']);
        }
      }, (error) => {
        console.log('there was an error sending the query', error);
        this.error = error.message;
        this.uploaded.next();
        this.userService.showAddExternal = false;
      });
  }


  // Initializing the component

  ngOnInit() {

    this.individualArtist = false;
    this.artistSelected = false;
    this.isArtistOrLabelSelected = false;
    this.isArtistSelected = false;
    this.submitted = false;
    this.error = '';
    this.flHidden = true;
    this.iaHidden = true;
    this.userExists = false;
    this.config = {
      backdrop: 'static',
      keyboard: false,
      animated: false
    };

    // GRAB LABELS FROM METADATA DB

    this.originalDefaultLabels = this.userService.originalDefaultLabels.labels;
    // console.log(this.originalDefaultLabels);
    this.defaultLabelsList = this.originalDefaultLabels.map((label) => {
      return label.name;
    });


    // GRAB COUNTRIES FROM METADATA DB

    this.originalCountriesList = this.userService.countryList.countries;
    this.countryList = this.originalCountriesList.map((country) => {
      return country.name;
    });

    // build reactive form model

    this.userFirstName = '';
    this.userLastName = '';
    this.userEmail = '';
    this.userCompany = '';
    this.userPhoneNumber = '';
    this.userCountry = '';
    this.selectedArtist = [];
    this.Urole = '';
    this.Utype = '';
    this.defaultLabels = '';
    this.tenant = 'uma';
    this.enableUmdAccessToggle = this.authService.userLoginType === 'admin' ? true : false;
    if (this.userService.isCopy) {
      this.Utype = this.userService.duplicateUser['type'] ? this.userService.duplicateUser['type'] : '';
      this.Urole = this.userService.duplicateUser['role'] ? this.userService.duplicateUser['role'] : '';
      this.userCountry = this.userService.duplicateUser['country'] ? this.userService.duplicateUser['country'].name : '';
      this.tenant = this.userService.duplicateUser['branding'] ? this.userService.duplicateUser['branding'] : 'uma';
      if (this.Urole === 'Affiliate Label' || this.Urole === 'Other') {
        this.userType = ['External VIP', 'External Restricted'];
        this.flHidden = false;
      } else {
        this.userType = ['External Restricted'];
        this.flHidden = true;
      }
      if (this.Urole === 'Affiliate Label') {
        this.iaHidden = true;
      } else {
        this.iaHidden = false;
      }
      if (this.userService.duplicateUser['defaultLabels']) {
        this.defaultLabels = this.userService.duplicateUser['defaultLabels'].name ?
          this.userService.duplicateUser['defaultLabels'].name : [];
        let i = this.userService.externalVip.indexOf(this.defaultLabels);
        if (i !== -1) {
          this.Utype = 'External VIP';
        } else {
          this.Utype = 'External Restricted';
        }
      } else {
        this.defaultLabels = '';
      }

      this.selectedArtist = this.userService.duplicateUser['artists'] ? this.userService.duplicateUser['artists'] : [];
      this.selectedArtist = this.selectedArtist.map((artist) => {
        return {
          _id: artist._id,
          name: artist.name,
          image: artist.image
        };
      });

      if (this.selectedArtist.length) {
        this.individualArtist = true;
      }
      // this.tenant =  this.userService.duplicateUser['tenant'] && this.userService.duplicateUser['tenant'] !== 'GLOBAL';
    }

    if (this.userService.isNewReqCopy) {
      this.userFirstName = this.userService.duplicateUser['firstName'] ? this.userService.duplicateUser['firstName'] : '';
      this.userLastName = this.userService.duplicateUser['lastName'] ? this.userService.duplicateUser['lastName'] : '';
      this.userEmail = this.userService.duplicateUser['email'] ? this.userService.duplicateUser['email'] : '';
      this.userCompany = this.userService.duplicateUser['company'] ? this.userService.duplicateUser['company'] : '';
      this.userCountry = this.userService.duplicateUser['country'] ? this.userService.duplicateUser['country'] : '';
      this.userPhoneNumber = this.userService.duplicateUser['phoneNumber'] ? this.userService.duplicateUser['phoneNumber'] : '';
      if (this.userService.duplicateUser['defaultLabels']) {
        this.defaultLabels = this.userService.duplicateUser['defaultLabels'] ?
          this.userService.duplicateUser['defaultLabels'][0].name : '';
        let i = this.userService.externalVip.indexOf(this.userService.duplicateUser['defaultLabels'][0].name);
        if (i !== -1) {
          this.Utype = 'External VIP';
        } else {
          this.Utype = 'External Restricted';
        }
      } else {
        this.defaultLabels = '';
      }
      // if(this.Urole === 'Affiliate Label' || this.Urole === 'Other') {
      //   this.userType = ['External VIP', 'External Restricted'];
      //   this.flHidden = false;
      // } else {
      //   this.userType = ['External Restricted'];
      //   this.flHidden = true;
      // }

      // this.selectedArtist = this.selectedArtist.map((artist) => {
      //   return {
      //     _id: artist._id,
      //     name: artist.name
      //   };
      // });
    }

    this.updateUserForm = this.formBuilder.group({
      firstName: [this.userFirstName, Validators.required],
      lastName: [this.userLastName, Validators.required],
      email: new FormControl(this.userEmail, [Validators.required, this.validateEmail]),
      company: [this.userCompany, Validators.required],
      phoneNumber: new FormControl(this.userPhoneNumber),
      country: new FormControl(this.userCountry, [Validators.required]),
      individualArtist: [this.individualArtist],
      revenueAccess: new FormControl(this.revenueAccess),
      discoverAccess: new FormControl(this.discoverAccess),
      Utype: new FormControl(this.Utype, [Validators.required]),
      Urole: new FormControl(this.Urole, [Validators.required]),
      defaultLabels: new FormControl(this.defaultLabels),
      subLabels: new FormControl(this.subLabels),
      dizzeeTenant: new FormControl(this.tenant)
    });
  }

  // Destroying the subscriptions

  ngOnDestroy() {
    this.submitted = false;
    this.error = '';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/users/user-form/new-user-form.component.ts